import breakpoints from './constants/breakpoints';
import generateTailwindTheme from './tailwindTheme';
import { ColorMap, ColorPalette, Colors } from './types';

import discoveryActionColors from './constants/colors/discovery/actionColors';
import discoveryColorPalette from './constants/colors/discovery/colorPalette';
import discoveryTextColors from './constants/colors/discovery/textColors';

import validationActionColors from './constants/colors/validation/actionColors';
import validationColorPalette from './constants/colors/validation/colorPalette';
import validationTextColors from './constants/colors/validation/textColors';

export class Theme<P extends ColorPalette, T extends ColorMap, A extends ColorMap> {
  private readonly colors: Colors<P, T, A>;
  readonly tailwindTheme: ReturnType<typeof generateTailwindTheme>;
  readonly htmlFontSize = 16;
  readonly breakpoints = breakpoints;

  constructor(colors: Colors<P, T, A>) {
    this.colors = colors;
    this.tailwindTheme = generateTailwindTheme<P, T, A>(this.colors);
  }

  get palette() {
    return this.colors.palette;
  }

  get textColors() {
    return this.colors.textColors;
  }

  get actionColors() {
    return this.colors.actionColors;
  }
}

const defaultDiscoveryColors: Colors<typeof discoveryColorPalette, typeof discoveryTextColors, typeof discoveryActionColors> = {
  palette: discoveryColorPalette,
  textColors: discoveryTextColors,
  actionColors: discoveryActionColors,
};

export class DefaultDiscoveryTheme extends Theme<typeof discoveryColorPalette, typeof discoveryTextColors, typeof discoveryActionColors> {
  constructor() {
    super(defaultDiscoveryColors)
  }
}

const defaultValidationColors: Colors<typeof validationColorPalette, typeof validationTextColors, typeof validationActionColors> = {
  palette: validationColorPalette,
  textColors: validationTextColors,
  actionColors: validationActionColors,
};

export class DefaultValidationTheme extends Theme<typeof validationColorPalette, typeof validationTextColors, typeof validationActionColors> {
  constructor() {
    super(defaultValidationColors)
  }
}
